"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateBrandBodyToJSON = exports.CreateBrandBodyFromJSONTyped = exports.CreateBrandBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
function CreateBrandBodyFromJSON(json) {
    return CreateBrandBodyFromJSONTyped(json, false);
}
exports.CreateBrandBodyFromJSON = CreateBrandBodyFromJSON;
function CreateBrandBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'image': json['image'],
    };
}
exports.CreateBrandBodyFromJSONTyped = CreateBrandBodyFromJSONTyped;
function CreateBrandBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'description': value.description,
        'image': value.image,
    };
}
exports.CreateBrandBodyToJSON = CreateBrandBodyToJSON;
